import Store from '@/store/index.js';
import Storage from '@/core/utils/storage';
import Vue from "vue";

// 1. 定义函数并导出为命名导出
export function isDark() {
    return Store.state?.theme() === 'dark';
}

const switchTheme = function () {
    const theme = isDark() ? 'light' : 'dark';
    console.log('准备切换主题：', theme)
    Storage.set("theme", theme);
    Store.commit("setTheme", theme);
}

export function changeTheme(theme) {
    console.log('准备切换主题：', theme)
    Storage.set("theme", theme);
    Store.commit("setTheme", theme);
}

// export function onThemeChange() {
// 	if (Busi.setOrGetAutoTheme()) {
// 		const systemInfo = uni.getSystemInfoSync()
// 		systemInfo.osTheme && changeTheme(systemInfo.osTheme)
// 	}
// 	uni.onThemeChange(switchTheme)
// }
// export function offThemeChange() {
// 	uni.offThemeChange(switchTheme)
// }
const Theme = {
    isDark,
    changeTheme,
    switchTheme
}
export default Vue.prototype.$Theme = Theme